import {

    ACTION_GET_STARASSIGNMENT_LIST,
    SET_STARASSIGNMENT_LIST,

    ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY,
    SET_STARASSIGNMENT_TYPE_CATEGORY,

    ACTION_POST_STARASSIGNMENT_ALL,
    ACTION_POST_STARASSIGNMENT_INDIVIDUAL,

    ACTION_GET_CARDSlIST,
    SET_CARDSLIST,

    ACTION_GET_STARTYPE_LIST,
    SET_STARTYPES_LIST,

    ACTION_GET_LIST_HISTORICAL_TEMPLATE,
    SET_LIST_HISTORICAL_TEMPLATE,

    ACTION_POST_TEMPLATE,
    SET_POST_TEMPLATE,

    ACTION_DOWNLOAD_TEMPLATE,
    SET_DOWNLOAD_TEMPLATE


} from "@/views/star_assignment/store/types/types.js";

import Swal from 'sweetalert2';
//import EventBus from '@/utils/event_bus.js';
import { StarAssignmentService } from "../../../services";

const actions = {

    [ACTION_GET_STARASSIGNMENT_LIST]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getTypeDocumentStarAssignment(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeDocumentStarassignment = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_STARASSIGNMENT_LIST, typeDocumentStarassignment);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_STARTYPE_LIST]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getTypeStar(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeStara = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_STARTYPES_LIST, typeStara);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getCategoryStarAssignment(idGroup, idEmpresa, idUsuario)
                    .then(resp => {

                        const typeCategoryStarAssignment = resp.data.payload;
                        commit(SET_STARASSIGNMENT_TYPE_CATEGORY, typeCategoryStarAssignment);
                        resolve(resp)
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_POST_STARASSIGNMENT_ALL]: ({ state }, data) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.postStarAssignmentAll({ idGroup, idEmpresa, idUsuario, data })
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: resp.data.payload.message,
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                            window.location.reload();
                        } else {
                            reject("La petición fue incorrecta o falló");
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_POST_STARASSIGNMENT_INDIVIDUAL]: ({ state }, data) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.postStarAssignmentInd({ idGroup, idEmpresa, idUsuario, data })
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: resp.data.payload.message,
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                            window.location.reload();
                        } else {
                            reject("La petición fue incorrecta o falló");
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CARDSlIST]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {

                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                StarAssignmentService.getCardsList(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_CARDSLIST, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_LIST_HISTORICAL_TEMPLATE]:({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                StarAssignmentService.getAllTemplates(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        const template = resp.data.payload;
                        commit(SET_LIST_HISTORICAL_TEMPLATE, template);
                        resolve(resp.data.payload);
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_POST_TEMPLATE]:({ state, commit }, data ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                StarAssignmentService.scatterStarsTemplates(idGroup, companyId, userId, data)
                    .then(async resp => {
                        commit(SET_POST_TEMPLATE, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });

    },

    [ACTION_DOWNLOAD_TEMPLATE]:({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                StarAssignmentService.downloadTemplate(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_DOWNLOAD_TEMPLATE, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });

    }

}

export default actions;